<template>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-cart">
    <div class="vx-col w-full sm:w-3/4 md:w-2/3 lg:w-3/4 xl:w-3/5">
      <vx-card title="Cart" title-color="primary" >
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col w-full d-theme-dark-bg">
              <div class="p-8">

                <div>
                    <vs-table stripe :data="products" class="table-fixed">
                    
                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                            <vs-td class="img-container">
                                <img :src="tr.image" class="product-img border border-solid d-theme-border-grey-light rounded-lg w-16 md:w-24 p-4" />
                            </vs-td>

                            <vs-td class="details-container">
                                <h6 class="product-name font-medium truncate">{{ tr.name }}</h6>
                                <p class="product-variation">{{ tr.category }}</p><!-- replace this with Variation, now is display purpose only -->
                                <div class="flex lg:hidden mobile-flex-center">
                                    <div class="flex-grow">
                                        <h6 class="product-price">${{ tr.price }}</h6>
                                        <div class="flex"> 
                                            <vs-input-number min="0" v-model="tr.quantity"/>
                                        </div>
                                    </div>
                                    <div>
                                        <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" class="float-right"/>
                                    </div>
                                </div>
                            </vs-td>
                            <vs-td class="price-container hidden lg:table-cell">
                                <h6 class="product-price">${{ tr.price }}</h6>
                            </vs-td>

                            <vs-td class="whitespace-no-wrap control-container hidden lg:table-cell">
                                <vs-input-number min="0" v-model="tr.quantity"/>
                            </vs-td>

                            <vs-td class="price-container hidden lg:table-cell">
                                <h6 class="product-price">${{ tr.price * tr.quantity }}</h6>
                            </vs-td>
                            <vs-td class="hidden lg:table-cell">
                                <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" />
                            </vs-td>
                        </vs-tr>
                        </tbody>
                    </template>
                    </vs-table>

                    <div class="vx-row mt-2">
                        <div class="vx-col w-1/2 lg:w-4/5 text-right">
                        <p>Sub Total :</p>
                        <p>Tax :</p>
                        <p><strong>Total :</strong></p>
                        <p>Coupon Code :</p>
                        </div>
                        <div class="vx-col w-1/2 lg:w-1/5 text-right">
                        <p>RM {{total}}</p>
                        <p>0 %</p>
                        <p><strong>RM {{total}}</strong></p>
                        <p><a class="cursor-pointer" @click="couponPopup=true">Select Coupon</a></p>
                        </div>
                    </div>
                  <vs-popup title="Billing Address" :active.sync="couponPopup">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                        <vs-input class="w-full" label-placeholder="Enter Code Here" v-model="couponCode" />
                        </div>
                    </div>
                    <div>
                      <div class="centerx mt-4 md:flex">
                        <vs-button type="border" icon-pack="feather" icon="icon-x" >Cancel</vs-button>
                        <vs-button type="filled" icon-pack="feather" icon="icon-check" class="shadow-md ml-auto" >Apply</vs-button>
                      </div>
                    </div>
                  </vs-popup>

                  <vs-divider/>

                  <div class="centerx mt-4 text-center">
                    <vs-button class="w-full mt-2 shadow-md" type="filled" icon-pack="feather" icon="icon-arrow-right" icon-after @click.prevent="$router.push({name: 'buyer-checkout'})">Checkout</vs-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      products: [
        {
        'id': 1,
        'category': 'computers',
        'image': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
        'name': 'Apple Watch series 4 GPS',
        'order_status': 'on_hold',
        'popularity': 97,
        'price': 69.99,
        'quantity': 0
        },
        {
        'id': 2,
        'category': 'fitness',
        'image': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/02.png',
        'name': 'Beats HeadPhones',
        'order_status': 'delivered',
        'popularity': 83,
        'price': 69.99,
        'quantity': 4
        },
        {
        'id': 3,
        'category': 'audio',
        'image': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/06.png',
        'name': 'Altec Lansing - Bluetooth Speaker',
        'order_status': 'canceled',
        'popularity': 57,
        'price': 199.99,
        'quantity': 5
        },
        {
        'id': 4,
        'category': 'fitness',
        'image': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/04.png',
        'name': 'Fitbit - Charge Wireless Activity Tracker (Large)',
        'order_status': 'pending',
        'popularity': 80,
        'price': 129.99,
        'quantity': 2
        },
        {
        'id': 5,
        'category': 'fitness',
        'image': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/09.png',
        'name': 'Fitbit - Sleep Tracker Wristband',
        'order_status': 'delivered',
        'popularity': 85,
        'price': 99.99,
        'quantity': 15
        }
      ],
      productAmount: 0,
      couponPopup: false,
      couponCode: ""
    }
  },
  computed: {
    total: function(){

      let total = [];

      Object.entries(this.products).forEach(([key, val]) => {
        total.push(val.price) // the value of the current key.
      });

      return total.reduce(function(total, num){ return total + num }, 0);

    }
  }
  
}
</script>

<style>
.vx-card .card-actions { position: absolute; top: -30px; right: 10px; }
.vx-card .vx-card__collapsible-content img { max-width: 100px; }
/* .td.vs-table--td.image-container, .td.vs-table--td.control-container { max-width: 25%; } */
/* .td.vs-table--td.details-container { max-width: 50%; } */
.vs-table--tbody-table .vs-table--td.td.details-container > span { display: block; width: calc(20vw - (4rem + 60px)) !important; }
@media screen and (max-width:768px) {
    .vs-table--tbody-table .vs-table--td.td.details-container > span { display: block; width: calc(47.5vw - (4rem + 60px)) !important; }
    .mobile-flex-center { align-items: center; justify-content: center; }
}
@media screen and (max-width:576px) {
    .vs-table--tbody-table {min-width: auto; }
    .router-view { padding: 0.5rem !important; }
    .vs-table--tbody-table .vs-table--td.td.details-container > span { display: block; width: calc(80vw - (4rem + 60px)) !important; }
}
</style>